// extracted by mini-css-extract-plugin
export default {"header":"blzgk","content":"r6Ohq","container":"WdJZg","menu":"SHuFi"};